import React from "react"

import { useIntl } from "react-intl"
import * as paths from "constants/paths"
import NavTabs from "components/Shared/NavTabs"
import { isFeatureEnabled } from "config/feature-flags"
import { INavTab } from "components/Shared/NavTabs/interfaces"
import TransactionalPerformance from "components/Transactional/Performance"
import { LEVEL_NAME_DEFAULT } from "components/Transactional/Performance/constants"
import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import {
	FilterLevelSelected,
	LevelName,
} from "components/Transactional/Performance/interfaces"

import { FEATURE_FLAG_VALUE_SHARE_MODEL_TAB } from "./TabsBenchmark.constants"

import "./TabsBenchmark.styles.scss"
import ValueShareModel from "components/Transactional/Benchmark/ValueShareModel"

type TabsBenchmarkProps = {
	period: string
	dateInterval: Interval
	levelName: LevelName
	labelFatherLevelName: string
	onChangeLevelName?: (levelName: LevelName) => void
	filterLevelSelected?: FilterLevelSelected
}

const TabsBenchmark = (props: TabsBenchmarkProps) => {
	const {
		period,
		dateInterval,
		levelName,
		labelFatherLevelName = LEVEL_NAME_DEFAULT,
		onChangeLevelName = () => undefined,
		filterLevelSelected,
	} = props

	const { formatMessage } = useIntl()

	const tabs: INavTab[] = [
		{
			text: formatMessage({
				id:
					"phronesis.transactional.application.commercial.benchmark.tabs.performance",
			}),
			pathname: paths.ROOT_CONTEXT + paths.TRANSACTIONAL_BENCHMARK,
			component: (
				<TransactionalPerformance
					period={period}
					dateInterval={dateInterval}
					levelName={levelName}
					labelFatherLevelName={labelFatherLevelName}
					onChangeLevelName={onChangeLevelName}
					filterLevelSelected={filterLevelSelected}
				/>
			),
		},
		{
			text: formatMessage({
				id:
					"phronesis.transactional.application.commercial.benchmark.tabs.value-shared-model",
			}),
			pathname: paths.ROOT_CONTEXT + paths.TRANSACTIONAL_VALUE_SHARED_MODEL,
			component: <ValueShareModel {...props} />,
			active: isFeatureEnabled(FEATURE_FLAG_VALUE_SHARE_MODEL_TAB),
		},
	]

	return <NavTabs tabs={tabs} className="module-tabs" />
}

export default TabsBenchmark
